import { render, staticRenderFns } from "./DownloadPendingAlert.vue?vue&type=template&id=0d9a7813&scoped=true&"
import script from "./DownloadPendingAlert.vue?vue&type=script&lang=js&"
export * from "./DownloadPendingAlert.vue?vue&type=script&lang=js&"
import style0 from "./DownloadPendingAlert.vue?vue&type=style&index=0&id=0d9a7813&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9a7813",
  null
  
)

export default component.exports